<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Outbound Order Summary
      </div>
    </div>
    <v-divider class="mt-1 mb-4 mr-2"></v-divider>
    <v-card class="pl-0">
      <v-card-title class="card-title"
        >Summary
        <v-tooltip
          bottom
          v-if="
            checkPermission('app_infor:b2b_outbound_asn_dn_closure_generate') &&
            summaryData.picking_and_dispatch_details.length > 0 &&
            (summaryData.picking_and_dispatch_details[0].ORDER_STATUS ==
              'Shipped Complete' ||
              summaryData.picking_and_dispatch_details[0].ORDER_STATUS ==
                'Delivered Accepted' ||
              summaryData.picking_and_dispatch_details[0].ORDER_STATUS ==
                'Delivered Rejected')
          "
        >
          <template v-slot:activator="{ on }">
            <v-icon medium class="mr-2 pl-4" v-on="on" @click="downloadASN()">
              mdi-receipt
            </v-icon>
          </template>
          <span>Delivery Note Download</span>
        </v-tooltip>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-row class="pl-0">
          <v-col cols="4">
            <v-col cols="12" class="pl-0">
              <div>
                <b>Order Details </b>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-5 p-0">Order Number</div>
                <div class="text-left col-md-7 p-0">
                  {{ summaryData.order_details.order_key }}
                </div>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-5 p-0">External No</div>
                <div class="text-left col-md-7 p-0">
                  {{ summaryData.order_details.order_no }}
                </div>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-5 p-0">Order Type</div>
                <div
                  class="text-left col-md-7 p-0"
                  v-if="summaryData.order_details.type"
                >
                  {{ summaryData.order_details.type }}
                </div>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-5 p-0">Carrier Code</div>
                <div class="text-left col-md-7 p-0">
                  {{ summaryData.order_details.carriercode }}
                </div>
              </div>

              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-5 p-0">Owner</div>
                <div
                  class="text-left col-md-7 p-0"
                  v-if="summaryData.order_details.storerkey"
                >
                  {{ summaryData.order_details.storerkey }}
                </div>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-5 p-0">Priority</div>
                <div class="text-left col-md-7 p-0">
                  {{ summaryData.order_details.priority }}
                </div>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-5 p-0">Request Delivery Date</div>
                <div
                  class="text-left col-md-7 p-0"
                  v-if="summaryData.order_details.requested_delivery_date"
                >
                  {{
                    summaryData.order_details.requested_delivery_date
                      | uaeDateTime
                      | moment("DD MMM, YYYY hh:mm A")
                  }}
                </div>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-5 p-0">Truck Ship Date</div>
                <div
                  class="text-left col-md-7 p-0"
                  v-if="summaryData.order_details.truck_ship_date"
                >
                  {{
                    summaryData.order_details.truck_ship_date
                      | uaeDateTime
                      | moment("DD MMM, YYYY hh:mm A")
                  }}
                </div>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-5 p-0">Ship To</div>
                <div class="text-left col-md-7 p-0">
                  {{ summaryData.order_details.ship_to }}
                </div>
              </div>

              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-5 p-0">Delivery Date 2</div>
                <div
                  class="text-left col-md-7 p-0"
                  v-if="summaryData.order_details.delivery_date_2"
                >
                  {{
                    summaryData.order_details.delivery_date_2
                      | uaeDateTime
                      | moment("DD MMM, YYYY hh:mm A")
                  }}
                </div>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-5 p-0">Order Group</div>
                <div class="text-left col-md-7 p-0">
                  {{ summaryData.order_details.order_group }}
                </div>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-5 p-0">Load Id</div>
                <div class="text-left col-md-7 p-0">
                  {{ summaryData.order_details.load_id }}
                </div>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-5 p-0">Purchase Order</div>
                <div class="text-left col-md-7 p-0">
                  {{ summaryData.order_details.purchase_order }}
                </div>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-5 p-0">Route</div>
                <div class="text-left col-md-7 p-0">
                  {{ summaryData.order_details.route }}
                </div>
              </div>
            </v-col>
          </v-col>
          <v-col cols="4">
            <v-col cols="12" class="pl-0">
              <div>
                <b>Order Details </b>
              </div>

              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-5 p-0">Stop</div>
                <div class="text-left col-md-7 p-0">
                  {{ summaryData.order_details.stop }}
                </div>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-5 p-0">Tralier No</div>
                <div class="text-left col-md-7 p-0">
                  {{ summaryData.order_details.trailer_number }}
                </div>
              </div>

              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-5 p-0">Order Date</div>
                <div
                  class="text-left col-md-7 p-0"
                  v-if="summaryData.order_details.order_date"
                >
                  {{
                    summaryData.order_details.order_date
                      | uaeDateTime
                      | moment("DD MMM, YYYY hh:mm A")
                  }}
                </div>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-5 p-0 text-medium-emphasis">Order Qty</div>
                <div
                  class="text-left col-md-7 p-0"
                  v-if="summaryData.picking_and_dispatch_details.length > 0"
                >
                  {{
                    changeNumberFormat(
                      summaryData.picking_and_dispatch_details[0].ORDER_QTY
                    )
                  }}
                </div>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-5 p-0 text-medium-emphasis">
                  Order Status
                </div>
                <div
                  class="text-left col-md-7 p-0"
                  v-if="summaryData.picking_and_dispatch_details.length > 0"
                >
                  {{ summaryData.picking_and_dispatch_details[0].ORDER_STATUS }}
                </div>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-5 p-0">Shipped Date</div>
                <div
                  class="text-left col-md-7 p-0"
                  v-if="summaryData.order_details.shipped_datetime"
                >
                  {{
                    summaryData.order_details.shipped_datetime
                      | uaeDateTime
                      | moment("DD MMM, YYYY hh:mm A")
                  }}
                </div>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-5 p-0 text-medium-emphasis">Transport</div>
                <div class="text-left col-md-7 p-0">
                  {{ summaryData.order_details.transport_mode }}
                </div>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-5 p-0 text-medium-emphasis">
                  External Order 2
                </div>
                <div class="text-left col-md-7 p-0">
                  {{ summaryData.order_details.external_order_2 }}
                </div>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-5 p-0 text-medium-emphasis">
                  Total Ordered Weight
                </div>
                <div class="text-left col-md-7 p-0">
                  {{ summaryData.order_details.total_ordered_weight }}
                </div>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-5 p-0 text-medium-emphasis">
                  Total Ordered Cube
                </div>
                <div class="text-left col-md-7 p-0">
                  {{ summaryData.order_details.total_ordered_cube }}
                </div>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-5 p-0 text-medium-emphasis">
                  Total Shipped Weight
                </div>
                <div class="text-left col-md-7 p-0">
                  {{ summaryData.order_details.total_shipped_weight }}
                </div>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-5 p-0 text-medium-emphasis">
                  Total Shipped Cube
                </div>
                <div class="text-left col-md-7 p-0">
                  {{ summaryData.order_details.total_shipped_cube }}
                </div>
              </div>
            </v-col>
          </v-col>
          <v-col cols="4">
            <v-col cols="12" class="pl-0">
              <div><b>Customer Details</b></div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-6 p-0 text-medium-emphasis">Name</div>
                <div class="text-left col-md-7 p-0">
                  {{ summaryData.address.customer }}
                </div>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-6 p-0 text-medium-emphasis">Address</div>
                <div class="text-left col-md-6 p-0">
                  {{ summaryData.address.address1 }}
                  <span v-if="summaryData.address.address1">,</span>
                  {{ summaryData.address.address2 }}
                </div>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-6 p-0">Contact No</div>
                <div class="text-left col-md-6 p-0">
                  {{ summaryData.address.contact_no }}
                </div>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-6 p-0">Email</div>
                <div class="text-left col-md-6 p-0">
                  {{ summaryData.address.email }}
                </div>
              </div>
            </v-col>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row
          class="pl-0"
          v-if="summaryData.picking_and_dispatch_details.length > 0"
        >
          <v-col cols="6">
            <v-col cols="12" class="pl-0">
              <div>
                <b>Picking & Dispatch</b>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-7 p-0 text-medium-emphasis">Shipped Qty</div>
                <div class="text-left col-md-5 p-0">
                  {{
                    changeNumberFormat(
                      summaryData.picking_and_dispatch_details[0].SHIPPED_QTY
                    )
                  }}
                </div>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-7 p-0 text-medium-emphasis">
                  Alloated Status Qty
                </div>
                <div class="text-left col-md-5 p-0">
                  {{
                    changeNumberFormat(
                      summaryData.picking_and_dispatch_details[0]
                        .QTY_IN_ALLOCATED_STATUS
                    )
                  }}
                </div>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-7 p-0 text-medium-emphasis">
                  Picked Status Qty
                </div>
                <div class="text-left col-md-5 p-0">
                  {{
                    changeNumberFormat(
                      summaryData.picking_and_dispatch_details[0]
                        .QTY_IN_PICKED_STATUS
                    )
                  }}
                </div>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-7 p-0">System Ship Date</div>
                <div
                  class="text-left col-md-5 p-0"
                  v-if="
                    summaryData.picking_and_dispatch_details[0].SYSTEM_SHIP_DATE
                  "
                >
                  {{
                    summaryData.picking_and_dispatch_details[0].SYSTEM_SHIP_DATE
                      | uaeDateTime
                      | moment("DD MMM, YYYY hh:mm A")
                  }}
                </div>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-7 p-0">Truck Ship Date</div>
                <div
                  class="text-left col-md-5 p-0"
                  v-if="
                    summaryData.picking_and_dispatch_details[0].TRUCK_SHIP_DATE
                  "
                >
                  {{
                    summaryData.picking_and_dispatch_details[0].TRUCK_SHIP_DATE
                      | uaeDateTime
                      | moment("DD MMM, YYYY hh:mm A")
                  }}
                </div>
              </div>
            </v-col>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row>
          <v-col class="pl-0">
            <v-data-table
              :headers="itemheaders"
              :items="orderDetails"
              disable-pagination
              :hide-default-footer="true"
              class="custom-class"
            >
              <template v-slot:[`item.created_at`]="{ item }">
                <span v-if="item.created_at">{{
                  item.created_at | uaeDateTime | moment("DD MMM, YYYY hh:mm A")
                }}</span>
              </template>
              <template v-slot:[`item.updated_at`]="{ item }">
                <span v-if="item.updated_at">{{
                  item.updated_at | uaeDateTime | moment("DD MMM, YYYY hh:mm A")
                }}</span>
              </template>
              <template v-slot:[`item.item_sku`]="{ item }">
                <label>
                  {{ item.item_sku }}
                </label>
              </template>
              <template v-slot:[`item.unit_price`]="{ item }">
                <label v-if="item.currency">
                  {{ item.unit_price }} ({{ item.currency }})
                </label>
                <label v-else>
                  {{ item.unit_price }}
                </label>
              </template>
              <template v-slot:[`item.description`]="{ item }"
                >{{ findDescription(item.sku, "description") }}
              </template>
              <template v-slot:[`item.tier`]="{ item }"
                >{{ findDescription(item.sku, "tier") }}
              </template>
              <template v-slot:[`item.mfg_date`]="{ item }">
                <span v-if="item.mfg_date">{{
                  item.mfg_date | uaeDateTime | moment("DD MMM, YYYY hh:mm A")
                }}</span>
              </template>
              <template v-slot:[`item.expiry_date`]="{ item }">
                <span v-if="item.expiry_date">{{
                  item.expiry_date
                    | uaeDateTime
                    | moment("DD MMM, YYYY hh:mm A")
                }}</span>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
    </v-card>
  </v-col>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  components: {},
  computed: {
    getEndDate() {
      var endDate = new Date();
      endDate.setDate(endDate.getDate() + 1);
      endDate.setHours(0, 0, 0, 0); // Set hours, minutes, seconds, and milliseconds to zero
      return endDate.toISOString().split("T")[0]; // Keep only the date part
    },
    ...mapGetters(["userRole", "userCategory"]),
  },
  data: () => ({
    warehouse_id: null,
    warehouses: [],
    to_date: null,
    from_date: null,
    dateMenu: false,
    dateMenuTo: false,
    order_key: null,
    receipt_no: null,
    selectedClient: null,
    stores: [],

    OutboundOrder: [],
    options: {},
    total: 0,
    summary: false,
    order_number: null,
    filtersArr: {},
    clients: [],
    summaryData: {
      order_details: {},
      address: {},
      picking_and_dispatch_details: [
        {
          QTY_IN_ALLOCATED_STATUS: null,
          ORDER_QTY: null,
          ORDER_STATUS: null,
          QTY_IN_PICKED_STATUS: null,

          SHIPPED_QTY: null,
          SYSTEM_SHIP_DATE: null,
          TRUCK_SHIP_DATE: null,
        },
      ],
    },
    itemheaders: [
      {
        text: "Sku",
        value: "sku",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Description",
        value: "description",
        class: "body-1 font-weight-bold",
        sortable: false,
        width: 200,
      },
      {
        text: "External Line No",
        value: "externlineno",
        class: "body-1 font-weight-bold",
        sortable: false,
        width: 200,
      },
      {
        text: "Allocation Strategy",
        value: "allocation_strategy",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Open Qty",
        value: "open_qty",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Pre Allocated Qty",
        class: "body-1 font-weight-bold",
        value: "pre_allocated_qty",
        sortable: false,
      },
      {
        text: "Allocated Qty",
        class: "body-1 font-weight-bold",
        value: "allocated_qty",
        sortable: false,
      },

      {
        text: "Picked Qty",
        class: "body-1 font-weight-bold",
        value: "picked_qty",
        sortable: false,
      },
      {
        text: "Shipped Qty",
        class: "body-1 font-weight-bold",
        value: "shipped_qty",
        sortable: false,
      },

      {
        text: "Unit Price",
        class: "body-1 font-weight-bold",
        value: "unit_price",
        sortable: false,
      },

      {
        text: "UOM",
        class: "body-1 font-weight-bold",
        value: "uom",
        sortable: false,
      },
      {
        text: "Reason Code",
        class: "body-1 font-weight-bold",
        value: "reason_code",
        sortable: false,
      },
      {
        text: "LPN",
        class: "body-1 font-weight-bold",
        value: "lpn",
        sortable: false,
      },

      {
        text: "Pack",
        class: "body-1 font-weight-bold",
        value: "pack",
        sortable: false,
      },
      {
        text: "Line",
        class: "body-1 font-weight-bold",
        value: "line",
        sortable: false,
      },
      {
        text: "Manufacturing Date",
        value: "mfg_date",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 120,
        sortable: false,
      },
      {
        text: "Expiry Date",
        value: "expiry_date",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 120,
        sortable: false,
      },
      {
        text: "lottable06",
        value: "lottable06",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 120,
        sortable: false,
      },
      {
        text: "lottable07",
        value: "lottable07",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 120,
        sortable: false,
      },
      {
        text: "lottable08",
        value: "lottable08",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 120,
        sortable: false,
      },
      {
        text: "lottable09",
        value: "lottable09",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 120,
        sortable: false,
      },
      {
        text: "lottable10",
        value: "lottable10",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 120,
        sortable: false,
      },
      {
        text: "Tier",
        value: "tier",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 120,
        sortable: false,
      },
      {
        value: "status",
        class: "body-1 font-weight-bold",
        text: "Status",
        sortable: false,
      },
      {
        text: "Created At",
        class: "body-1 font-weight-bold",
        value: "created_at",
        sortable: false,
      },

      {
        text: "Updated At",
        class: "body-1 font-weight-bold",
        value: "updated_at",
        sortable: false,
      },
    ],
    orderDetails: [],
    statuses: [],
    allocatesStatus: [{ text: "Yes", value: "yes" }],
    allocated: "",
    status: "",
    selectedItem: {},
  }),

  watch: {
    options: {
      handler() {},
      deep: true,
    },
  },
  created() {
    this.outboundorderSummary(this.$route.query.id).then((res) => {
      this.orderDetails = res.data.data.items;
      this.summaryData = res.data.data;
      this.summary = true;
    });
  },

  methods: {
    ...mapActions(["outboundorderSummary", "downloadOutboundASN"]),
    findDescription(id, type) {
      if (type == "description") {
        return this.summaryData.description_dict[id].description;
      } else if (type == "tier") {
        if (this.summaryData.description_dict[id])
          return this.summaryData.description_dict[id].tier;
      }
    },
    downloadASN() {
      this.downloadOutboundASN(this.$route.query.id)
        .then((res) => {
          this.fileDownload(res);
          this.downloader = false;
        })
        .catch(() => {
          this.downloader = false;
        });
    },
  },
};
</script>
<style scoped>
.custom-row {
  display: flex !important;
  flex-wrap: wrap !important;
  padding: 5px 0px 5px 5px !important;
}
.p-0 {
  padding: 0px !important;
}
</style>
